import React, { useState } from 'react';
import * as actions from './store/vehicleActions';
import { connect } from 'react-redux';
import { withStyles, LinearProgress } from '@material-ui/core';
import VehicleList from './VehicleList';
import VehicleCreate from './VehicleCreate';
import VehicleDelete from './VehicleDelete';
import VehicleEdit from './VehicleEdit'
import * as action from '../../np-core/Auth/store/authActions';
import { hasPermission } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
});

const Vehicle = (props) => {
    const { vehicle, classes, activeCustomer, permissions } = props;
    const fetching = vehicle.fetching;
    const [addModalState, setAddModalState] = useState({ open: false, customers: [] });
    const [editModalState, setEditModalState] = useState({ open: false, customers: [] });
    const [deleteModalState, setDeleteModalState] = useState({ VehicleID: null, VehicleIDs: [], open: false, forBulk: false });

    const handleCreate = async (event) => {
        if (!event) {
            setAddModalState({ open: false, customers: [] });
            return;
        }
        let data = await props.fetchCustomers({ ActiveCustomerID: activeCustomer });
        setAddModalState({ open: true, customers: data });
    };

    const handleDelete = async (event) => {
        if (!event) {
            setDeleteModalState({ ...deleteModalState, open: false });
            return;
        }
        setDeleteModalState({ ...deleteModalState, VehicleID: event.currentTarget.value, open: true });
    };

    const handleEdit = async (event) => {
        if (!event) {
            setEditModalState({ open: false, customers: [] });
            return;
        }
        let vehicleID = event.currentTarget.value;
        await props.loadVehicle({ VehicleID: vehicleID, ActiveCustomerID: activeCustomer });
        let data = await props.fetchCustomers({ ActiveCustomerID: activeCustomer });
        setEditModalState({ open: true, customers: data });
    };

    return <>
        {hasPermission(permissions, 'vehicle_list') ?
            <div>
                <div className={classes.progressBarr}>
                    {fetching ? <LinearProgress color="primary" /> : null}
                </div>
                <VehicleList columnsState={props.columns} saveColumnsFilter={props.saveColumnsFilter} vehicles={props.vehicle} fetchVehicles={props.fetchVehicles} permissions={permissions} handleCreate={handleCreate} handleDelete={handleDelete} handleEdit={handleEdit} />
            </div>
            : null}
        {hasPermission(permissions, 'vehicle_create') ? <VehicleCreate activeCustomer={activeCustomer} open={addModalState.open} customers={addModalState.customers} handleOpen={handleCreate} createVehicle={props.createVehicle} /> : null}
        {hasPermission(permissions, 'vehicle_delete') ? <VehicleDelete activeCustomer={activeCustomer} entityName={'Vehicle'} handleDelete={handleDelete} deleteModalState={deleteModalState} onDeleteVehicle={props.deleteVehicle} /> : null}
        {hasPermission(permissions, 'vehicle_load') ? <VehicleEdit activeCustomer={activeCustomer} handleEdit={handleEdit} open={editModalState.open} vehicle={vehicle.loaded} editVehicle={props.editVehicle} customers={editModalState.customers} /> : null}
    </>
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        vehicle: state.vehicle.vehicles,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        fetchVehicles: filterParams => dispatch(actions.fetchVehicles(filterParams)),
        loadVehicle: filterParams => dispatch(actions.loadVehicle(filterParams)),
        createVehicle: data => dispatch(actions.createVehicle(data)),
        editVehicle: data => dispatch((actions.editVehicle(data))),
        deleteVehicle: filterParams => dispatch((actions.deleteVehicle(filterParams))),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        fetchCustomers: () => dispatch(actions.fetchCustomers())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Vehicle));
